var i = function i(_i, r) {
  var t, l;
  if (!_i) return {
    width: 0,
    height: 0
  };
  var d = "//img2.storyblok.com",
    e = _i.replace("//a.storyblok.com", "").replace("https:", ""),
    f = !1 === (null == r ? void 0 : r.smart) || (null == r ? void 0 : r.focus) ? "" : "/smart",
    s = (null == r ? void 0 : r.focus) ? "/filters:focal(" + r.focus + ")" : "",
    o = e.match(/\/(\d*)x(\d*)\//),
    u = parseInt(null == o ? void 0 : o[1]) || void 0,
    a = parseInt(null == o ? void 0 : o[2]) || void 0;
  if (r) {
    if (r.fixed) return {
      src: "" + d + f + s + e,
      srcSet: d + "/" + r.fixed[0] + "x" + r.fixed[1] + f + s + e + " 1x,\n      " + d + "/" + 2 * r.fixed[0] + "x" + 2 * r.fixed[1] + f + "/filters:quality(70)" + (s ? null === (t = s.split("filters")) || void 0 === t ? void 0 : t[1] : "") + e + " 2x,\n      " + d + "/" + 3 * r.fixed[0] + "x" + 3 * r.fixed[1] + f + "/filters:quality(50)" + (s ? null === (l = s.split("filters")) || void 0 === l ? void 0 : l[1] : "") + e + " 3x,",
      width: u,
      height: a
    };
    if (r.fluid) {
      for (var n = [.25, .5, 1, 1.5, 2], h = [], x = Array.isArray(r.fluid) ? r.fluid[0] : r.fluid, v = Array.isArray(r.fluid) ? r.fluid[1] : 0, c = 0; c < n.length; c += 1) {
        var p = Math.round(n[c] * x);
        if (!u || n[c] * x <= u) h.push(d + "/" + p + "x" + Math.round(n[c] * v) + f + s + e + " " + p + "w");else if (u && n[c] <= 1) {
          h.push(d + "/" + p + "x" + Math.round(n[c] * v) + f + s + e + " " + u + "w");
          break;
        }
      }
      return {
        sizes: "(max-width: " + x + "px) 100vw, " + x + "px",
        srcSet: h.join(", "),
        src: d + "/" + x + "x" + v + f + s + e,
        width: u,
        height: a
      };
    }
  }
  return {
    src: "" + d + f + s + e,
    width: u,
    height: a
  };
};
export { i as getImageProps };